// Minimal JS i18n shim mirroring Rails' I18n.t / I18n.l API.
//
// Translations are inlined into the page by the layout as a single global
// `window.I18nTranslations`, sourced from `{js: I18n.t('js')}` server-side
// — so JS callsites can use the same `js.*` key prefix as Ruby code.
// See `app/views/layouts/_head.html.erb`.
//
// Plural rules are hardcoded for de + en (`one` for count == 1, `other`
// otherwise). Add CLDR rules here if more locales arrive.

const FALLBACK_LOCALE = 'de';


function lookup(key) {
  const path = key.split('.');
  let value = window.I18nTranslations;
  for (const k of path) {
    if (value == null) return undefined;
    value = value[k];
  }
  return value;
}


function interpolate(template, opts) {
  return template.replace(/%\{(\w+)\}/g, (_, name) => {
    const v = opts[name];
    return v == null ? `%{${name}}` : v;
  });
}


function pluralize(branches, count) {
  // de + en: count == 1 -> 'one', else 'other'.
  return (count === 1 ? branches.one : branches.other) ?? branches.other ?? null;
}


const I18n = {
  get locale() {
    const raw = document.documentElement.lang || FALLBACK_LOCALE;
    return raw.split(/[-_]/)[0];
  },

  t(key, opts = {}) {
    let value = lookup(key);
    if (value == null) {
      console.warn(`I18n: missing translation: ${key}`);
      return `[missing: ${key}]`;
    }
    if (typeof value === 'object') {
      if (opts.count != null) {
        const branch = pluralize(value, opts.count);
        if (branch == null) {
          console.warn(`I18n: missing plural branch for ${key}`);
          return `[missing plural: ${key}]`;
        }
        value = branch;
      } else {
        console.warn(`I18n: ${key} resolves to a hash but no count given`);
        return `[non-string: ${key}]`;
      }
    }
    return interpolate(String(value), opts);
  },

  l(value, opts = {}) {
    if (value instanceof Date) return new Intl.DateTimeFormat(this.locale, opts).format(value);
    if (typeof value === 'number') return new Intl.NumberFormat(this.locale, opts).format(value);
    return String(value);
  },
};

window.I18n = I18n;
export default I18n;
